import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SuccessSnackbar } from '../success-snackbar/success-snackbar';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-error-snackbar',
  imports: [MatIconModule],
  templateUrl: './error-snackbar.html',
  styleUrl: './error-snackbar.scss'
})
export class ErrorSnackbar {
  constructor(
    public snackBarRef: MatSnackBarRef<ErrorSnackbar>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string }
  ) { }
  
  close() {
    this.snackBarRef.dismiss();
  }
}
